import React from 'react'
import { Redirect, Route, useRouteMatch } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { withTranslation } from 'react-i18next'

const PrivateRoute = ({ component: Component, t, ...rest }) => {
  const isAuthenticated = useSelector((state) => state.authentication.authenticated)
  const match = useRouteMatch()
  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: `${match.path}${t('routes.privacy_notice')}`,
              state: { from: props.location },
            }}
          />
        )
      }
    />
  )
}

export default withTranslation('common')(PrivateRoute)
